import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import { getOptionLabel } from "common/enums";
import Collapse from "./Collapse";

const FloorWiseFireExtinguisherView = ({
  floorWiseFireExtinguishers,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Floors",
        key: "floors",
        renderField: (floors) =>
          floors.length ? floors.map(({ name }) => name).join(", ") : "N/A",
      },
      {
        name: "Fire Extinguisher Type",
        key: "extinguisherType",
        renderField: (value) =>
          getOptionLabel("fireExtinguisherTypeEnum", value),
      },
      {
        name: "Capacity (Kg)",
        key: "capacity",
        isRequired: true,
      },
      {
        name: "Quantity",
        key: "quantity",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse
        title="Floor Wise Fire Extinguisher Details"
        isExpandable={isExpandable}
      >
        {floorWiseFireExtinguishers.map((extinguisher, index) => (
          <Fragment key={extinguisher.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Fire Extinguisher") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(extinguisher, key, "");

                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(extinguisher, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

FloorWiseFireExtinguisherView.propTypes = {
  floorWiseFireExtinguishers: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(FloorWiseFireExtinguisherView);
